import { PredefinedAdditionalServiceEnum } from 'src/app/models/enums/BookingEnums';

import { Vehicle } from './../../../models/Vehicle';
import { BookingService } from './../../../services/booking.service';
import { Component, OnInit } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { SearchService } from './../../../services/search.service';

import { faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
import { ReservationSaveAndConfirmModel } from 'src/app/models/Booking/ReservationSaveAndConfirmModel';
import { ActivatedRoute, Router } from '@angular/router';
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum';
import { AttachmentService } from 'src/app/services/attachment.service';
import { DriverSkillModel } from 'src/app/models/Booking/DriverSkillModel';

// import * as jspdf from 'jspdf';
// declare var jsPDF: any;





@Component({
  selector: 'confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.css']
})
export class ConfirmationComponent implements OnInit {

  BookedCar;
  faArrowAltCircleRight = faArrowAltCircleRight;
  currency;
  vehicle: Vehicle;
  reservationCaseResult;
  reservationSaveAndConfirmModel: ReservationSaveAndConfirmModel;
  isPrinting: boolean;
  editMode:false;
  extendMode:false;

  driverSkills: DriverSkillModel[];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private bookingService: BookingService,
    private currencyService: SearchService,
    private attachmentService: AttachmentService,
  ) {

    this.currency = currencyService.getCurrency();
  }

  ngOnInit() {
    let caseID   = this.route.snapshot.queryParams.caseID==null? this.route.snapshot.params.caseID: this.route.snapshot.queryParams.caseID;
    let editMode = this.route.snapshot.queryParams.editMode==null? this.route.snapshot.params.editMode: this.route.snapshot.queryParams.editMode;
    let extendMode = this.route.snapshot.queryParams.extendMode==null? this.route.snapshot.params.extendMode: this.route.snapshot.queryParams.extendMode;

    if(editMode){
      this.editMode=editMode;
    }

    if(extendMode){
      //boolean value not string
      this.extendMode=JSON.parse(this.route.snapshot.params.extendMode);
      //
    }





    if (caseID != null) {

      this.bookingService.getVehicleReservationCase(caseID).subscribe(res => {




        this.reservationCaseResult = res;
        let driver=res.vehicleReservationDetailsModel.lstAdditionalServiceReservationCase.filter(a=>a.predefinedAdditionalServiceID==PredefinedAdditionalServiceEnum.Drivers)[0];
        if(driver!=null){
          this.bookingService.getDriverSkills().subscribe(skills => {
            //res.

            let selectedSkillID=driver.agencyDriverBaseRatesSkills.map(a =>a .driverSkillID);

            this.driverSkills = skills.filter(o => selectedSkillID.includes(o.driverSkillID ));

          })
        }

      })

    }
  }



  get attachmentScopesEnum() {
    return AttachmentScopesEnum;
  }
  get attachmentTypeEnum() {
    return AttachmentTypeEnum;
  }
  public get predefinedAdditionalServiceEnum(): typeof PredefinedAdditionalServiceEnum {
    return PredefinedAdditionalServiceEnum;
  }
  viewBooking() {

    this.router.navigate(['/view-booking', { CaseID: this.reservationCaseResult.caseID }]);
  }

  printClicked() {
    this.isPrinting = true;
    setTimeout(() => {
      window.print();
      this.isPrinting = false;
    });

    /* this.printService
    .printDocument('ConfirmationComponent', {caseID: this.reservationCaseResult.caseID,isPrintMode:true }); */
  }


}
